(function () {
  const KEY = 'rt70_ymm';
  const DATA_URL = window.rt70YmmDataUrl;
  let dataPromise;

  function parse(value) {
    try {
      return JSON.parse(value);
    } catch (_error) {
      return null;
    }
  }

  const YMM = {
    get: () => parse(localStorage.getItem(KEY) || 'null'),
    set(value) {
      localStorage.setItem(KEY, JSON.stringify(value));
      document.dispatchEvent(new CustomEvent('rt70:ymm-change', { detail: value }));
    },
    clear() {
      localStorage.removeItem(KEY);
      document.dispatchEvent(new CustomEvent('rt70:ymm-change', { detail: null }));
    },
  };

  function normalize(value) {
    return String(value || '').toLowerCase().replace(/\s+/g, ' ').trim();
  }

  function loadData() {
    if (!dataPromise) {
      dataPromise = fetch(DATA_URL).then((response) => {
        if (!response.ok) throw new Error('No se pudieron cargar las motos.');
        return response.json();
      });
    }
    return dataPromise;
  }

  function parseFitment(raw) {
    if (!raw) return null;
    let value = typeof raw === 'string' ? parse(raw) : raw;
    if (typeof value === 'string') value = parse(value);
    return Array.isArray(value) ? value : null;
  }

  function checkFitment(raw, storedYMM) {
    const list = parseFitment(raw);
    if (!list || !storedYMM) return 'unknown';
    const match = list.some((fitment) =>
      Number(fitment.y) === Number(storedYMM.y) &&
      normalize(fitment.m) === normalize(storedYMM.m) &&
      normalize(fitment.mo) === normalize(storedYMM.mo)
    );
    return match ? 'compatible' : 'incompatible';
  }

  function setOptions(select, values, placeholder) {
    select.innerHTML = `<option value="">${placeholder}</option>`;
    values.forEach((value) => {
      const option = document.createElement('option');
      option.value = value;
      option.textContent = value;
      select.appendChild(option);
    });
    select.disabled = values.length === 0;
  }

  function initSelector(root) {
    const year = root.querySelector('[data-rt70-year]');
    const make = root.querySelector('[data-rt70-make]');
    const model = root.querySelector('[data-rt70-model]');
    const submit = root.querySelector('[data-rt70-submit]');
    const summary = root.querySelector('[data-rt70-saved-bike]');
    if (!year || root.dataset.ready) return;
    root.dataset.ready = 'true';

    loadData().then((map) => {
      const years = Object.keys(map).sort((a, b) => Number(b) - Number(a));
      setOptions(year, years, '1. Selecciona el año');

      const stored = YMM.get();
      if (stored && map[stored.y]?.[stored.m]?.includes(stored.mo)) {
        year.value = String(stored.y);
        setOptions(make, Object.keys(map[stored.y] || {}).sort(), '2. Selecciona la marca');
        make.value = stored.m;
        setOptions(model, (map[stored.y]?.[stored.m] || []).slice().sort(), '3. Selecciona el modelo');
        model.value = stored.mo;
        submit.disabled = false;
        if (summary) {
          summary.dataset.active = 'true';
          summary.innerHTML = `<strong>Tu moto: ${stored.y} ${stored.m} ${stored.mo}</strong><button class="rt70-ymm-link" type="button" data-rt70-clear>Cambiar</button>`;
        }
      }

      year.addEventListener('change', () => {
        setOptions(make, Object.keys(map[year.value] || {}).sort(), '2. Selecciona la marca');
        setOptions(model, [], '3. Selecciona el modelo');
        submit.disabled = true;
      });

      make.addEventListener('change', () => {
        setOptions(model, (map[year.value]?.[make.value] || []).slice().sort(), '3. Selecciona el modelo');
        submit.disabled = true;
      });

      model.addEventListener('change', () => {
        submit.disabled = !model.value;
      });

      submit.addEventListener('click', () => {
        const selected = { y: Number(year.value), m: make.value, mo: model.value };
        YMM.set(selected);
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({ event: 'ymm_search_submitted', ymm_year: selected.y, ymm_make: selected.m, ymm_model: selected.mo });
        const dialog = root.closest('dialog');
        if (dialog) {
          dialog.close();
          window.location.reload();
        } else {
          const query = encodeURIComponent(`${selected.y} ${selected.m} ${selected.mo}`);
          window.location.href = `/search?q=${query}&options[prefix]=last&rt70_ymm=1`;
        }
      });
    }).catch(() => {
      setOptions(year, [], 'Error al cargar motos');
    });
  }

  function hydrateBar() {
    const bar = document.querySelector('[data-rt70-ymm-bar]');
    if (!bar) return;
    const bike = YMM.get();
    bar.dataset.active = bike ? 'true' : 'false';
    bar.innerHTML = bike
      ? `<span>Tu moto: <strong>${bike.y} ${bike.m} ${bike.mo}</strong> &nbsp; <button class="rt70-ymm-link" data-rt70-open>Cambiar</button> &nbsp; <button class="rt70-ymm-link" data-rt70-clear>×</button></span>`
      : '<span>Selecciona tu moto para ver piezas compatibles &nbsp; <button class="rt70-ymm-link" data-rt70-open>Seleccionar →</button></span>';
  }

  function hydratePdp() {
    const banner = document.querySelector('[data-rt70-pdp-fitment]');
    if (!banner) return;
    const bike = YMM.get();
    const status = checkFitment(banner.dataset.fitment, bike);
    banner.dataset.status = status;
    if (status === 'compatible') {
      banner.innerHTML = `<strong>✓ Compatible con tu moto</strong><br>${bike.y} ${bike.m} ${bike.mo}`;
    } else if (status === 'incompatible') {
      banner.innerHTML = `<strong>Confirma compatibilidad antes de comprar</strong><br>No encontramos ${bike.y} ${bike.m} ${bike.mo} en la lista de esta pieza. <a href="https://wa.me/529981088181" target="_blank" rel="noopener">Preguntar por WhatsApp</a>`;
    }
  }

  document.addEventListener('click', (event) => {
    if (event.target.closest('[data-rt70-open]')) document.querySelector('#rt70-ymm-dialog')?.showModal();
    if (event.target.closest('[data-rt70-clear]')) {
      YMM.clear();
      window.location.reload();
    }
    if (event.target.closest('[data-rt70-close]')) document.querySelector('#rt70-ymm-dialog')?.close();
    if (event.target.closest('[data-rt70-menu]')) document.querySelector('header-drawer summary')?.click();
  });

  function init() {
    document.querySelectorAll('[data-rt70-selector]').forEach(initSelector);
    hydrateBar();
    hydratePdp();
  }

  window.RT70YMM = { YMM, normalize, parseFitment, checkFitment, init };
  document.dispatchEvent(new CustomEvent('rt70:ymm-ready'));
  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('rt70:ymm-change', init);
})();
